<template>
  <div class="body">
      <Headtow></Headtow>
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>专家介绍</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 左侧 -->
        <div class="w-expert">
          <ul id="products-content" class="expert-content expert-content-border"  v-loading="loading">
              <li>
                  <div class="expert-content-left">
                       <img :src="info.picurl" alt="">
                  </div>
                  <div class="products-content-center expert-content-center">
                      <p class="products-content-center-title">{{info.title}}<span>{{info.zw}}</span></p>
                      <p class="expert-content-center-jianjie ov2">{{info.rz}}</p>
                      <p class="expert-content-center-shanchang ov1"><span>擅长：</span>{{info.sc}}</p>
                      <p class="expert-content-center-shanchang ov2"><span>简介：</span>{{info.introduction}}</p>
                  </div>
                  <div class="products-content-right">
                     <!-- <el-button>产品咨询</el-button> -->
                     <div class="h-40"></div>
                     <el-button  @click="dialogFormVisiblezj = true">专家帮我挑</el-button>
                  </div>
                  <div class="clear"></div>

               </li>
          </ul>
          <el-dialog title="专家帮我挑" :visible.sync="dialogFormVisiblezj" >
              <Productzjzj :productid='info.id' :title='info.title' @handleClosezj="handleClosezj"></Productzjzj>
          </el-dialog>
        </div>
        <!-- 左侧结束 -->
        <!-- 详情 -->
        <div class="h-20"></div>
        <p class="products-right-title">专家介绍</p>
        <div id="content">
          <div v-html="info.content"></div>
        </div>
        <p class="products-right-title">产品推荐</p>
        <ul id="products-content" class="ExpertCont-tj" v-loading="loading">
            <li v-for="(item, index) in left" :key="item.id">
              <router-link  :to="{path:'/ProductsCont',query: {id: item.id}}">
                <div class="products-content-left">
                    <img :src="item.picurl" alt="">
                </div>
                <div class="products-content-center">
                    <p class="products-content-center-title ov1">{{item.title}}</p>
                    <p class="products-content-center-jianjie ov2">{{item.introduction}}</p>
                    <p class="products-content-center-bq">{{item.money}}</p>
                    <p class="products-content-center-gsmc ov1">{{item.gsname}} </p>
                </div>
                <div class="clear"></div>
              </router-link>
             </li>
        </ul>
      </div>
      <Foot></Foot>
  </div>
</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import productzjzj from '@/components/public/productzjzj.vue'
export default{
  data(){
    return {
     dialogFormVisiblezj: false,
     loading:true,
     info:[],
     left:{},
     id:'',
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Productzjzj': productzjzj,
  },
  mounted () {
    this.id = this.$route.query.id;
    console.log(this.id);
    this.recordapi();
  },
  methods:{
   recordapi(){
       var that = this;
       that.$api.post("/Products/ExpertCont",{'id':that.id}).then(res => {
         console.log(res);
         that.info= res.info;
         that.left= res.left.data;
         that.loading = false
       });
   },
   // 关闭弹窗
   handleClosezj() {
     this.dialogFormVisiblezj = false
   },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/ExpertCont.vue